<template>
  <div>
    <Corporates :type="$data._corporateType.industry.value" />
  </div>
</template>

<script>
import Corporates from './Corporates'
export default {
  components: {
    Corporates
  },
  name: 'Industries'
}
</script>